<template>
    <div class="header-wrapper">
        <div class="header">
            <div class="logo" @click.stop="goToHome"></div>
            <ul class="nav-bar">
                <li
                    class="nav"
                    :class="
                        activeTitle && activeTitle.id == item.id
                            ? 'active-nav'
                            : 'each-nav'
                    "
                    v-for="item in navList"
                    :key="item.id"
                >
                    <template v-if="item.children && item.children.length > 0">
                        <el-popover
                            placement="bottom"
                            trigger="hover"
                            width="106"
                            :visible-arrow="false"
                            popper-class="header-popper"
                        >
                            <div slot="reference" class="header-title">
                                {{ item.title }}
                            </div>
                            <div class="sub-nav-wrapper">
                                <ul class="sub-nav">
                                    <li
                                        class="each-sub-nav"
                                        @click.stop="linkTo(each, item)"
                                        v-for="each in item.children"
                                        :key="each.id"
                                    >
                                        <span>{{ each.title }}</span>
                                    </li>
                                </ul>
                            </div>
                        </el-popover>
                    </template>
                    <div
                        v-else
                        @click.stop="redirectToPage(item)"
                        class="header-title"
                    >
                        {{ item.title }}
                    </div>
                </li>
            </ul>
        </div>
        <div class="swipper">
            <el-carousel
                :autoplay="true"
                indicator-position="none"
                arrow="hover"
                :height="bannerHeight"
                :interval="3000"
                style="overflow: hidden"
            >
                <el-carousel-item
                    v-for="(item, index) in bannerList"
                    :key="index"
                >
                    <img
                        v-show="item"
                        class="swiper-img"
                        :src="item.pic_url"
                        @click="jump(item.jump_url)"
                        alt
                    />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="breadcrumb-wrapper" v-if="homeType != 1">
            <div class="breadcrumb">
                <img src="../../assets/common/logo-white.png" />
                <span class="link-btn" @click.stop="goToHome">首页</span>/
                <span class="link-btn" v-if="activeTitle">{{
                    activeTitle.title
                }}</span
                >/
                <span class="link-btn" v-if="subActiveTitle">{{
                    subActiveTitle.title
                }}</span>
            </div>
        </div>
    </div>
</template>

<script>
const homeBannerHeight = "518px";
const commonBannerHeight = "178px";
export default {
    name: "Header",
    props: {},
    data() {
        return {
            navList: [],
            bannerList: [],
            activeTitle: null,
        };
    },
    computed: {
        homeType() {
            this.activeTitle = this.$store.state.activeTitle;
            let homeType = this.activeTitle ? this.activeTitle.type : 1;
            if (homeType == 1 && this.activeTitle) {
                this.getBannerList(this.activeTitle.id);
            }
            this.$store.commit("homeType", homeType);
            return homeType;
        },
        bannerHeight() {
            return this.homeType == 1 ? homeBannerHeight : commonBannerHeight;
        },
        subActiveTitle() {
            let subActiveTitle = this.$store.state.subActiveTitle;
            if (this.homeType != 1 && subActiveTitle) {
                this.getBannerList(subActiveTitle.id);
            }
            return this.$store.state.subActiveTitle;
        },
    },
    mounted() {
        this.getNavList();
    },
    methods: {
        getBannerList(categoryId) {
            this.$axios
                .get(`${window.API.getBannerList}${categoryId}`)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.bannerList = data.data;
                    }
                })
                .catch();
        },
        jump(url) {
            if (url) {
                window.open(url);
            }
        },
        goToHome() {
            sessionStorage.removeItem("isListPage");
            this.$router.replace({
                name: "Home",
            });
            let arr = this.navList.filter((e) => e.type == 1);
            if (arr.length > 0) {
                sessionStorage.activeTitle = JSON.stringify(arr[0]);
                this.$store.commit("activeTitle");
            }
        },
        redirectToPage(params) {
            sessionStorage.removeItem("isListPage");
            this.$router.replace({ path: "/" });
            sessionStorage.activeTitle = JSON.stringify(params);
            this.$store.commit("activeTitle");
        },
        linkTo(params, parent) {
            sessionStorage.removeItem("isListPage");
            sessionStorage.activeTitle = JSON.stringify(parent);
            sessionStorage.subActiveTitle = JSON.stringify(params);
            sessionStorage.clickHeader = 1;
            this.$store.commit("activeTitle");
            this.$store.commit("subActiveTitle");
            this.$router.replace({
                name: "Page",
                params: { titleId: params.id },
            });
        },
        getNavList() {
            this.$axios
                .get(`${window.API.homeNav}`)
                .then(({ data }) => {
                    if (
                        data.code == 200 &&
                        data.data instanceof Array &&
                        data.data.length > 0
                    ) {
                        this.navList = data.data;
                        let url = window.location.href;
                        //从url截取参数
                        if (url.includes("/") > -1) {
                            let arr = url.split("/");
                            let obj, subObj;
                            if (arr[arr.length - 1].includes("?")) {
                                let subArr = arr[arr.length - 1].split("?");
                                if (subArr == "") {
                                    let ar = this.navList.filter(
                                        (e) => e.type == 1
                                    );
                                    if (ar.length > 0) {
                                        obj = ar[0];
                                    }
                                } else {
                                    this.navList.forEach((element) => {
                                        let el = element.children.find(
                                            (e) => e.id == subArr[0]
                                        );
                                        if (el) {
                                            obj = element;
                                            subObj = el;
                                        }
                                    });
                                }
                            } else if (arr[arr.length - 1] == "") {
                                let ar = this.navList.filter(
                                    (e) => e.type == 1
                                );
                                if (ar.length > 0) {
                                    obj = ar[0];
                                }
                            } else {
                                this.navList.forEach((element) => {
                                    let el = element.children.find(
                                        (e) => e.id == arr[arr.length - 1]
                                    );
                                    if (el) {
                                        obj = element;
                                        subObj = el;
                                    }
                                });
                            }
                            if (obj) {
                                sessionStorage.activeTitle = JSON.stringify(
                                    obj
                                );
                                this.$store.commit("activeTitle");
                                if (subObj) {
                                    sessionStorage.subActiveTitle = JSON.stringify(
                                        subObj
                                    );
                                    this.$store.commit("subActiveTitle");
                                }
                            }
                        }
                    }
                })
                .catch((err) => console.log(err));
        },
    },
};
</script>

<style scoped lang="scss">
.header-wrapper/deep/ {
    width: 100%;
    background: #ffffff;
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;

        .logo {
            background: url("../../../src/assets/common/logo-black.png") center
                center no-repeat;
            background-size: 100%;
            width: 153px;
            height: 48px;
        }

        .nav-bar {
            display: flex;
            justify-content: flex-end;
            overflow-y: hidden;
            .active-nav {
                padding-top: 17px;
                color: #ffffff;
                background: url("../../../src/assets/common/nav-back.png")
                    center center no-repeat;
                background-size: 100% 70px;
            }

            .each-nav {
                color: #555555;
                cursor: pointer;
                .header-title {
                    padding-top: 17px;
                    font-size: 17px;
                    font-weight: 600;
                }
                &:hover {
                    color: #ffffff;
                    background: url("../../../src/assets/common/nav-back.png")
                        center center no-repeat;
                    background-size: 100% 70px;
                }
            }
            .nav {
                text-align: center;
                width: 106px;
                height: 70px;
                line-height: 42px;

                &:hover .sub-nav-wrapper {
                    display: block;
                }

                .sub-nav-wrapper {
                    position: absolute;
                    box-sizing: border-box;
                    background: rgba(0, 41, 56, 0.58);
                    padding: 0 16px;
                    top: 80px;
                    right: 52px;
                    max-width: 282px;
                    display: none;
                    z-index: 10000;

                    .sub-nav {
                        .each-sub-nav {
                            display: flex;
                            align-items: center;
                            flex-shrink: 0;
                            font-weight: 400;
                            color: #ffffff;
                            cursor: pointer;
                            &:hover {
                                color: #ffb62e;
                            }
                            height: 60px;
                            font-size: 16px;
                            line-height: 22px;
                        }
                    }
                }
            }
            font-size: 16px;
        }
    }
    .el-carousel__item {
        width: 100%;
        height: 100%;
        .swiper-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .breadcrumb-wrapper {
        width: 100%;
        background: #f6f6f6;
        .breadcrumb {
            display: flex;
            align-items: center;
            max-width: 1200px;
            margin: 0 auto;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            padding: 15px 0;
            img {
                width: 9px;
                height: 12px;
            }
            span {
                margin: 0 5px;
            }
            font-size: 14px;
            .link-btn {
                cursor: pointer;

                &:hover {
                    font-weight: 600;
                }
            }
        }
    }
}
</style>
